import { ENV_CONFIG } from "../../../constants/envConfig";
import { convertPhoneNumberAsPerSbmChannel } from "../../global/utils/commonUtils";
const contactNumber = convertPhoneNumberAsPerSbmChannel(ENV_CONFIG.SUPPORT_CONTACT_NUMBER);
export const imageWidth = 56;
export const imageHeight = 56;

export const CART_AEM_CONFIG_VALUES = {
    THROTTLE_PROPERTIES: 'throttleproperties',
    GENERIC_PROPERTIES: 'genericproperties',
    ALERTS_PROPERTIES: 'alertmessages',
    MODALS_PROPERTIES: 'modalproperties',
    SIMILAR_ITEMS_PROPERTIES: 'similaritems',
    ACCESSORIES_PROPERTIES: 'accessoriesproperties'
}
const SupportNumber = convertPhoneNumberAsPerSbmChannel(ENV_CONFIG.SUPPORT_CONTACT_NUMBER);
export const AUTHORABLE_FALLBACK = {
    zeroQtyForSpecificMilliSecond: 200,
    throttleDelayForInputBox: 800,
    throttleDelayForIncDecCounterButtons: 500,
    cartTitle: 'Cart',
    rentalTitle: 'Rentals',
    unavailableRentalTitle: 'Unavailable Rentals',
    enableAlertMessage: true,
    alertMessage: 'Some items in your cart are no longer available for your rental.',
    ctaLink: 'View Details',
    ariaLabelContent: 'Some items in your cart are no longer available for your rental.',
    weekendRentalTitle: 'Weekend rentals',
    weekendRentalMessage: 'Rentals over the weekend may qualify for a reduced total cost. Ask your in-store specialist for details when you get your equipment.',
    unavailableRentalAlert: 'This item is not available near you.',
    modalTitle: 'All items in your cart are unavailable',
    message: `<p>At least one available item must be in your cart before you can check out.</p><br><p>Questions? Call us at <a href="tel:${contactNumber}">${contactNumber}</a></p>`,
    ctaLabel: 'Ok',
    maxAccessories: '3',
    maxAddOns: '3',
    maxAddonsQuantityLimit: '25',
    maxQuantityLimit: '25'
};